(async function () {
  const firebaseAppModule = await import(
    "https://www.gstatic.com/firebasejs/12.1.0/firebase-app.js"
  );

  const firebaseAuthModule = await import(
    "https://www.gstatic.com/firebasejs/12.1.0/firebase-auth.js"
  );

  const firestoreModule = await import(
    "https://www.gstatic.com/firebasejs/12.1.0/firebase-firestore.js"
  );

  const {
    initializeApp
  } = firebaseAppModule;

  const {
    getAuth,
    onAuthStateChanged,
    signInAnonymously
  } = firebaseAuthModule;

  const {
    addDoc,
    collection,
    doc,
    getFirestore,
    onSnapshot,
    orderBy,
    query,
    serverTimestamp,
    setDoc,
    updateDoc
  } = firestoreModule;

  const firebaseConfig = {
    apiKey: "AIzaSyB7KndUVPLNduAH-TAjaMM6sAaEeL_rCQM",
    authDomain: "elektripood-chat.firebaseapp.com",
    projectId: "elektripood-chat",
    storageBucket: "elektripood-chat.firebasestorage.app",
    messagingSenderId: "819564946064",
    appId: "1:819564946064:web:e8e66068c8927726a06e15",
    measurementId: "G-M3R2MGRR9M"
  };

  const app = initializeApp(firebaseConfig);
  const auth = getAuth(app);
  const db = getFirestore(app);

  const button =
    document.getElementById("ep-chat-button");

  const chatWindow =
    document.getElementById("ep-chat-window");

  const closeButton =
    document.getElementById("ep-chat-close");

  const form =
    document.getElementById("ep-chat-form");

  const input =
    document.getElementById("ep-chat-input");

  const messagesElement =
    document.querySelector(".ep-chat-messages");

  const sendButton =
    document.getElementById("ep-chat-send");

  const statusTitle =
    document.getElementById(
      "ep-chat-status-title"
    );

  const statusText =
    document.getElementById(
      "ep-chat-status-text"
    );

  if (
    !button ||
    !chatWindow ||
    !closeButton ||
    !form ||
    !input ||
    !messagesElement ||
    !sendButton ||
    !statusTitle ||
    !statusText
  ) {
    console.error(
      "Elektripood chat: vajalikud elemendid puuduvad."
    );

    return;
  }

  let currentUser = null;

  let conversationId =
    localStorage.getItem(
      "elektripood_chat_conversation_id"
    );

  let unsubscribeMessages = null;
  let sending = false;

  input.disabled = true;
  sendButton.disabled = true;
  input.placeholder =
    "Vestlusega ühendamine...";

  function updateChatAvailability() {
    try {
      const estoniaTime =
        new Intl.DateTimeFormat(
          "et-EE",
          {
            timeZone: "Europe/Tallinn",
            hour: "2-digit",
            minute: "2-digit",
            hour12: false
          }
        ).format(new Date());

      const parts =
        estoniaTime.split(":");

      const hour =
        Number(parts[0]);

      const minute =
        Number(parts[1]);

      const minutesNow =
        hour * 60 + minute;

      const opensAt =
        8 * 60;

      const closesAt =
        22 * 60;

      const isOnline =
        minutesNow >= opensAt &&
        minutesNow < closesAt;

      if (isOnline) {
        button.classList.remove(
          "is-offline"
        );

        statusTitle.textContent =
          "OLEME KOHAL";

        statusText.textContent =
          "Räägi päris elektrikuga";

        button.setAttribute(
          "aria-label",
          "Ava live-chat. Oleme kohal."
        );
      } else {
        button.classList.add(
          "is-offline"
        );

        statusTitle.textContent =
          "HETKEL EEMAL";

        statusText.textContent =
          "Jäta meile sõnum";

        button.setAttribute(
          "aria-label",
          "Ava chat ja jäta meile sõnum."
        );
      }
    } catch (error) {
      console.error(
        "Chati staatuse uuendamine ebaõnnestus:",
        error
      );
    }
  }

  updateChatAvailability();

  setInterval(
    updateChatAvailability,
    60 * 1000
  );

  /* LOETUD-OLEKU MÄRKIMINE */

  async function markReadByCustomer() {
    if (!conversationId || !currentUser) {
      return;
    }

    try {
      await updateDoc(
        doc(
          db,
          "conversations",
          conversationId
        ),
        {
          lastReadByCustomerAt:
            serverTimestamp(),
          unreadByCustomer: 0
        }
      );
    } catch (error) {
      console.error(
        "Loetud oleku salvestamine ebaõnnestus:",
        error
      );
    }
  }

function openChat() {
  button.classList.remove("is-minimized");

  localStorage.removeItem(
    "elektripood_chat_minimized"
  );

  chatWindow.classList.add(
    "is-open"
  );

  chatWindow.setAttribute(
    "aria-hidden",
    "false"
  );

  button.setAttribute(
    "aria-expanded",
    "true"
  );

  button.classList.add(
    "chat-open"
  );

  markReadByCustomer();

  setTimeout(function () {
    input.focus();
  }, 100);
}

function closeChat() {
  chatWindow.classList.remove(
    "is-open"
  );

  chatWindow.setAttribute(
    "aria-hidden",
    "true"
  );

  button.setAttribute(
    "aria-expanded",
    "false"
  );

  button.classList.remove(
    "chat-open"
  );
}

const minimizeButton =
  document.getElementById("ep-chat-minimize");

// Kui kasutaja pani ikooni väikseks,
// jäta see ka järgmisel lehel väikseks.
if (
  localStorage.getItem(
    "elektripood_chat_minimized"
  ) === "true"
) {
  button.classList.add(
    "is-minimized"
  );
}
document.documentElement.classList.remove(
  "ep-chat-start-minimized"
);

if (minimizeButton) {
  minimizeButton.addEventListener(
    "click",
    function (event) {
      event.preventDefault();
      event.stopPropagation();

      closeChat();

      button.classList.add(
        "is-minimized"
      );

      localStorage.setItem(
        "elektripood_chat_minimized",
        "true"
      );
    }
  );
}

button.addEventListener(
  "click",
  function () {
    if (
      chatWindow.classList.contains(
        "is-open"
      )
    ) {
      closeChat();
    } else {
      openChat();
    }
  }
);

closeButton.addEventListener(
  "click",
  function (event) {
    event.preventDefault();
    event.stopPropagation();

    closeChat();
  }
);

  onAuthStateChanged(
    auth,
    async function (user) {
      try {
        if (!user) {
          await signInAnonymously(auth);
          return;
        }

        currentUser = user;

        input.disabled = false;
        input.placeholder =
          "Kirjuta sõnum...";

        updateSendButton();

        if (conversationId) {
          listenToMessages(
            conversationId
          );
        }
      } catch (error) {
        console.error(
          "Anonüümne sisselogimine ebaõnnestus:",
          error
        );

        input.placeholder =
          "Vestlusega ühendamine ebaõnnestus";
      }
    }
  );

  form.addEventListener(
    "submit",
    async function (event) {
      event.preventDefault();

      const text =
        input.value.trim();

      if (
        !text ||
        !currentUser ||
        sending
      ) {
        return;
      }

      sending = true;
      updateSendButton();

      try {
        if (!conversationId) {
          conversationId =
            await createConversation(
              text
            );

          localStorage.setItem(
            "elektripood_chat_conversation_id",
            conversationId
          );

          listenToMessages(
            conversationId
          );
        } else {
          await addMessage(
            conversationId,
            text
          );
        }

        input.value = "";
        updateSendButton();
      } catch (error) {
        console.error(
          "Sõnumi saatmine ebaõnnestus:",
          error
        );

        alert(
          "Sõnumi saatmine ebaõnnestus."
        );
      } finally {
        sending = false;
        updateSendButton();
      }
    }
  );

  input.addEventListener(
    "input",
    updateSendButton
  );

  input.addEventListener(
    "keydown",
    function (event) {
      if (
        event.key === "Enter" &&
        !event.shiftKey
      ) {
        event.preventDefault();
        form.requestSubmit();
      }
    }
  );

  function updateSendButton() {
    sendButton.disabled =
      !currentUser ||
      sending ||
      input.value.trim().length === 0;
  }

  async function createConversation(
    firstMessage
  ) {
    const conversationReference =
      doc(
        collection(
          db,
          "conversations"
        )
      );

    await setDoc(
      conversationReference,
      {
        customerUid:
          currentUser.uid,
        status: "open",
        source: "shopify",
        createdAt:
          serverTimestamp(),
        updatedAt:
          serverTimestamp(),
        lastMessage:
          firstMessage,
        lastMessageAt:
          serverTimestamp(),
        lastMessageSender:
          "customer",
        unreadByAdmin: 1,
        archived: false,
        pageTitle:
          document.title,
        pageUrl:
          window.location.href
      }
    );

    await addDoc(
      collection(
        db,
        "conversations",
        conversationReference.id,
        "messages"
      ),
      {
        text: firstMessage,
        sender: "customer",
        senderUid:
          currentUser.uid,
        createdAt:
          serverTimestamp()
      }
    );

    return conversationReference.id;
  }

  async function addMessage(
    activeConversationId,
    text
  ) {
    await addDoc(
      collection(
        db,
        "conversations",
        activeConversationId,
        "messages"
      ),
      {
        text: text,
        sender: "customer",
        senderUid:
          currentUser.uid,
        createdAt:
          serverTimestamp()
      }
    );

    await updateDoc(
      doc(
        db,
        "conversations",
        activeConversationId
      ),
      {
        lastMessage: text,
        lastMessageAt:
          serverTimestamp(),
        lastMessageSender:
          "customer",
        updatedAt:
          serverTimestamp(),
        unreadByAdmin: 1,
        archived: false
      }
    );
  }

  function listenToMessages(
    activeConversationId
  ) {
    if (unsubscribeMessages) {
      unsubscribeMessages();
    }

    const messagesQuery =
      query(
        collection(
          db,
          "conversations",
          activeConversationId,
          "messages"
        ),
        orderBy(
          "createdAt",
          "asc"
        )
      );

    unsubscribeMessages =
      onSnapshot(
        messagesQuery,
        function (snapshot) {
          messagesElement.innerHTML =
            "";

          snapshot.forEach(
            function (
              messageDocument
            ) {
              const message =
                messageDocument.data();

              renderMessage(
                message
              );
            }
          );

          messagesElement.scrollTop =
            messagesElement.scrollHeight;

          // Kui vestlusaken on juba lahti, siis
          // uued sõnumid loetakse kohe loetuks.
          if (
            chatWindow.classList.contains(
              "is-open"
            )
          ) {
            markReadByCustomer();
          }
        },
        function (error) {
          console.error(
            "Sõnumite laadimine ebaõnnestus:",
            error
          );
        }
      );
  }

  function renderMessage(message) {
    const messageElement =
      document.createElement(
        "div"
      );

    messageElement.className =
      "ep-chat-message";

    if (
      message.sender ===
      "customer"
    ) {
      messageElement.classList.add(
        "ep-chat-message--customer"
      );
    }

    messageElement.textContent =
      message.text || "";

    messagesElement.appendChild(
      messageElement
    );
  }
})().catch(function (error) {
  console.error(
    "Elektripood chati käivitamine ebaõnnestus:",
    error
  );
});
